import React, { useEffect, useState } from "react";
import Topbar from "../../Layouts/Superadmin_layout/Superadmin_topbar";
import "../../Styles/Pages/admin_fieldofficers.css";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Pagination,
  Typography,
  Button,
  Modal,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { instance } from "../../utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchIcon from "@mui/icons-material/Search";
import { alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
  border: "1px solid #79c245",
  marginRight: "10px",
}));
const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#79c245",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  fontFamily: "Poppins,sans-serif",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

function StatusFieldOfficers() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const { id } = useParams();
  const [officers, setOfficers] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredOfficers, setFilteredOfficers] = useState([]);
  const [vendorName, setVendorName] = useState("");
  const navigate = useNavigate();
  const [resetstatus, setResetStatus] = useState(null);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [activeSearch, setActiveSearch] = useState();
  const [inactiveSearch, setInactiveSearch] = useState();

  const handleStatusOpen = (officer) => {
    setOpenStatusModal(true);
    setResetStatus(officer);
  };

  const handleStatusClose = () => {
    setOpenStatusModal(false);
  };

  const handlenavigate = () => {
    navigate(`/superadmin/AllDetails/${id}`);
  };

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearch(query);

    let officersToSearch;
    if (status === "active") {
      officersToSearch = activeSearch;
    } else if (status === "inactive") {
      officersToSearch = inactiveSearch;
    } else {
      officersToSearch = officers;
    }

    if (query === "") {
      setFilteredOfficers(officersToSearch);
    } else {
      const filtered = officersToSearch.filter((officer) =>
        Object.values(officer).some((value) =>
          value.toString().toLowerCase().includes(query)
        )
      );
      setFilteredOfficers(filtered);
    }
    setCurrentPage(1);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const officersPerPage = 10;
  const indexOfLastOfficer = currentPage * officersPerPage;
  const indexOfFirstOfficer = indexOfLastOfficer - officersPerPage;
  const currentOfficers = filteredOfficers.slice(
    indexOfFirstOfficer,
    indexOfLastOfficer
  );

  const formattedDate = (isDate) => {
    const date = new Date(isDate);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options).replace(/\//g, "-");
  };

  const fetchFieldOfficers = async () => {
    try {
      const response = await instance.get(
        `/vendor/getVendorDetails?vendor_id=${id}`
      );
      setVendorName(response.data.vendor.name);
      const activeOfficers = response.data.FD.filter(
        (officer) => officer.status === true
      );
      const inactiveOfficers = response.data.FD.filter(
        (officer) => officer.status === false
      );
      setActiveSearch(activeOfficers);
      setInactiveSearch(inactiveOfficers);
      setOfficers(response.data.FD);
      if (status === "active") {
        setFilteredOfficers(activeOfficers);
      } else if (status === "inactive") {
        setFilteredOfficers(inactiveOfficers);
      } else {
        setFilteredOfficers(response.data.FD);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchMobileAccess = async (hash) => {
    try {
      const response = await instance.get(
        `/field_officer/resetMobileToken?fieldofficer_hash=${hash}`
      );
      if (response.status === 200) {
        toast.success(response.data.msg);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchFieldOfficers();
  }, [id]);

  const style = {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    borderColor: "none",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <div style={{ padding: "20px 20px 0px 0px" }}>
        <Topbar />
        <div style={{ padding: "20px 0px 0px 0px" }}>
          <section className="main_box">
            <div className="container-fluid">
            <div className="table_box">
              <TableContainer component={Paper}>
                <div className="table_inbox">
                  <div className="add_user_list">
                    <div className="add_user_content">
                      <div
                        style={{
                          fontFamily: "Poppins,sans-serif",
                          fontSize: "20px",
                          fontWeight: "bold",
                        }}
                      >
                        {status === "active" ? "Active" : "Inactive"} Field
                        Officers of {vendorName}
                      </div>
                    </div>
                    <div className="add_user">
                      <div>
                        <Search>
                          <SearchIconWrapper>
                            <SearchIcon />
                          </SearchIconWrapper>
                          <StyledInputBase
                            type="search"
                            placeholder="Search…"
                            inputProps={{ "aria-label": "search" }}
                            value={search}
                            onChange={handleSearch}
                          />
                        </Search>
                      </div>
                      <Button
                        className="table-button"
                        variant="outlined"
                        onClick={handlenavigate}
                      >
                        Back
                      </Button>
                    </div>
                  </div>
                  <Table
                    className="adduser_table user_table product_table"
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow className="table_head">
                        <TableCell align="center" className="first-child">
                          Sl.No
                        </TableCell>
                        <TableCell align="center" className="first-child">
                          Employee ID
                        </TableCell>
                        <TableCell align="center" className="second-child">
                          Field Officer Name
                        </TableCell>
                        <TableCell align="center">Email</TableCell>
                        <TableCell align="center" className="third-child">
                          Mobile
                        </TableCell>
                        <TableCell align="center" className="third-child">
                          Experience
                        </TableCell>
                        <TableCell align="center">Joining Date</TableCell>
                        <TableCell align="center">Device Access</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="table_body">
                      {currentOfficers.length > 0 ? (
                        currentOfficers.map((officer, index) => (
                          <TableRow key={officer._id}>
                            <TableCell align="center">
                              {index + 1 + (currentPage - 1) * officersPerPage}
                            </TableCell>
                            <TableCell align="center">
                              {officer.employee_id}
                            </TableCell>
                            <TableCell align="center">{officer.name}</TableCell>
                            <TableCell align="center">
                              {officer.email}
                            </TableCell>
                            <TableCell align="center">
                              {officer.mobile_no}
                            </TableCell>
                            <TableCell align="center">
                              {officer.experience}
                            </TableCell>
                            <TableCell align="center">
                              {formattedDate(officer.createdAt)}
                            </TableCell>
                            <TableCell align="center">
                              <button
                                className="reset-button"
                                variant="contained"
                                onClick={() => handleStatusOpen(officer.hash)}
                              >
                                Reset
                              </button>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableCell colSpan={12} align="center">
                          <Typography>No matched items</Typography>
                        </TableCell>
                      )}
                    </TableBody>
                  </Table>
                  <div className="pagination_table">
                    <Pagination
                      count={Math.ceil(
                        filteredOfficers.length / officersPerPage
                      )}
                      page={currentPage}
                      onChange={(event, page) => setCurrentPage(page)}
                      shape="rounded"
                      variant="outlined"
                    />
                  </div>
                </div>
              </TableContainer>
              <Modal
                open={openStatusModal}
                onClose={handleStatusClose}
                aria-labelledby="delete-modal-title"
                aria-describedby="delete-modal-description"
              >
                <Box sx={style}>
                  <div id="delete-modal-title">
                    {`Do you want to reset mobile access token of this officer ?`}
                  </div>
                  <div id="delete-modal-description">
                    <Button
                      variant="contained"
                      className="yes"
                      onClick={() => {
                        fetchMobileAccess(resetstatus);
                        setOpenStatusModal(false);
                      }}
                    >
                      Yes
                    </Button>
                    <Button
                      variant="contained"
                      className="no"
                      onClick={handleStatusClose}
                    >
                      No
                    </Button>
                  </div>
                </Box>
              </Modal>
            </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default StatusFieldOfficers;
